document.addEventListener('DOMContentLoaded', function () {
	const filterCountElement = document.getElementById('filter-count');

	// Função para atualizar a contagem de filtros
	function updateFilterCount() {
		let count = document.querySelectorAll('.taxonomy-terms').length;
		filterCountElement.textContent = count;
	}

	// Listener para links de remoção de filtros
	removeFilterLinks.forEach(link => {
		link.addEventListener('click', function (event) {
			event.preventDefault();
			// Simula a remoção do filtro
			this.parentElement.remove();
			updateFilterCount();
		});
	});

});
